module.exports = __webpack_public_path__ + "img/inst.d87f27fe.svg";